import { createSlice } from "@reduxjs/toolkit";
import {
  getAllCategoriesService,
  createCategorieservice,
  deleteCategorieservice,
  getCategoryByIdService,
  updateCategorieservice,
} from "../services/categories_service";

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  categoryList: [],
  metaCategory: null,
  categoryInfo: null,
  isLoadingAction: false,
  subCategories:[]
};

const slice = createSlice({
  name: "categories",
  initialState,
  reducers: {
    setCategoryInfoNull: (state, action) => {
      state.categoryInfo = null;
  
    },
  },
  extraReducers: (builder) => {
    // Using builder callback notation
    builder
      .addCase(getAllCategoriesService.fulfilled, (state, action) => {
        state.isLoading = false;
        state.categoryList = action.payload?.data?.data?.data;
        state.metaCategory =action.payload?.data?.data;
      })
      .addCase(getAllCategoriesService.rejected, (state) => {
        state.isLoading = false; // Corrected the property name
      })
      .addCase(getAllCategoriesService.pending, (state) => {
        state.isLoading = true; // Corrected the property name
      })
      .addCase(getCategoryByIdService.fulfilled, (state, action) => {
        state.isLoading = false;
        state.categoryInfo = action.payload?.data?.data;
        state.subCategories=action.payload.data.data.sub_categories
      })
      .addCase(getCategoryByIdService.rejected, (state) => {
        state.isLoading = false; // Corrected the property name
      })
      .addCase(getCategoryByIdService.pending, (state) => {
        state.isLoading = true; // Corrected the property name
      })
      .addCase(createCategorieservice.fulfilled, (state, action) => {
        state.isLoadingAction = false;
      })
      .addCase(createCategorieservice.rejected, (state) => {
        state.isLoadingAction = false; // Corrected the property name
      })
      .addCase(createCategorieservice.pending, (state) => {
        state.isLoadingAction = true; // Corrected the property name
      })
      .addCase(updateCategorieservice.fulfilled, (state, action) => {
        state.isLoadingAction = false;
      })
      .addCase(updateCategorieservice.rejected, (state) => {
        state.isLoadingAction = false; // Corrected the property name
      })
      .addCase(updateCategorieservice.pending, (state) => {
        state.isLoadingAction = true; // Corrected the property name
      });
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { setCategoryInfoNull } = slice.actions;
